import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "dl-page"
};
const _hoisted_2 = {
  class: "dl-hero"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  key: 0,
  class: "dl-wechat"
};
const _hoisted_5 = {
  class: "dl-main"
};
const _hoisted_6 = {
  class: "shots__viewport"
};
const _hoisted_7 = ["src", "alt", "onError"];
const _hoisted_8 = {
  key: 1,
  class: "shot__placeholder"
};
const _hoisted_9 = {
  class: "shots__dots"
};
const _hoisted_10 = ["aria-label", "onClick"];
const _hoisted_11 = {
  class: "dl-info"
};
const _hoisted_12 = {
  key: 0,
  class: "dl-hint"
};
const _hoisted_13 = {
  class: "dl-actions"
};
const _hoisted_14 = {
  key: 1,
  class: "dl-qr"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "brand-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "选择手机品牌"
};
const _hoisted_18 = {
  class: "brand-list"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "brand-modal__foot"
};
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { ElMessage } from 'element-plus';
import NavBar from '@/components/layout/NavBar.vue';
import Footer from '@/components/layout/Footer.vue';
import homeShot from '@/assets/imgs/03.jpg';
import iosQr from '@/assets/imgs/app-ios-qr.png';
import androidQr from '@/assets/imgs/app-android-qr.png';

/* ========== 设备判断 ========== */

export default {
  __name: 'Download',
  setup(__props) {
    const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent;
    const isWechat = /MicroMessenger/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isAndroid = !isIOS && /Android/i.test(ua);
    const isDesktop = !isIOS && !isAndroid;
    const suggested = ref(isIOS ? 'ios' : isAndroid ? 'android' : '');
    const deviceHint = computed(() => {
      if (isIOS) return '检测到你在用 iPhone，已为你标出 App Store';
      if (isAndroid) return '检测到你在用 Android，可走应用市场，也可以直接装 APK';
      return '在电脑上浏览？用手机扫码安装最快';
    });

    /* ========== 截图轮播 ========== */
    const screens = [{
      id: 1,
      label: '首页 · 近七天睡眠',
      src: homeShot
    }, {
      id: 2,
      label: '助眠音频',
      src: '/app/screen-2.jpg'
    }, {
      id: 3,
      label: '睡眠报告',
      src: '/app/screen-3.jpg'
    }];
    const shotIndex = ref(0);
    const missingShots = ref([]);
    let shotTimer = null;
    const prefersReducedMotion = () => typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const stopShots = () => {
      if (shotTimer) {
        window.clearInterval(shotTimer);
        shotTimer = null;
      }
    };
    const startShots = () => {
      stopShots();
      shotTimer = window.setInterval(() => {
        shotIndex.value = (shotIndex.value + 1) % screens.length;
      }, 4200);
    };
    const pauseShots = () => stopShots();
    const resumeShots = () => {
      if (!prefersReducedMotion()) startShots();
    };
    const goToShot = index => {
      shotIndex.value = index;
      resumeShots();
    };
    const onShotError = id => {
      if (!missingShots.value.includes(id)) missingShots.value = [...missingShots.value, id];
    };
    let touchStartX = 0;
    const onTouchStart = event => {
      touchStartX = event.changedTouches[0].clientX;
    };
    const onTouchEnd = event => {
      const delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) < 40) return;
      const step = delta < 0 ? 1 : -1;
      shotIndex.value = (shotIndex.value + step + screens.length) % screens.length;
      resumeShots();
    };

    /* ========== 下载入口 ========== */
    const brandList = [{
      key: 'huawei',
      name: '华为 / 荣耀',
      scheme: 'appmarket://details?id=com.sleeptight.ihealth'
    }, {
      key: 'xiaomi',
      name: '小米 / Redmi',
      scheme: 'mimarket://details?id=com.sleeptight.ihealth'
    }, {
      key: 'oppo',
      name: 'OPPO / 一加 / realme',
      scheme: 'oppomarket://details?packagename=com.sleeptight.ihealth'
    }, {
      key: 'vivo',
      name: 'vivo / iQOO',
      scheme: 'vivomarket://details?id=com.sleeptight.ihealth'
    }];
    const showBrandModal = ref(false);
    const openBrandModal = () => {
      showBrandModal.value = true;
      document.documentElement.classList.add('brand-open');
    };
    const closeBrandModal = () => {
      showBrandModal.value = false;
      document.documentElement.classList.remove('brand-open');
    };
    const goToBrandStore = brand => {
      closeBrandModal();
      window.location.href = brand.scheme;
    };
    const handleDownload = platform => {
      if (platform === 'ios') {
        window.open('https://apps.apple.com/us/app/sleep-tight/id6738379204', '_blank');
        return;
      }
      if (platform === 'android') {
        if (!isAndroid) {
          ElMessage.info('请在安卓手机上打开本页选择品牌商店；电脑上可以扫码安装');
          return;
        }
        openBrandModal();
        return;
      }
      if (platform === 'apk') {
        closeBrandModal();
        window.open('https://www.stst-ibs.com/Sleep_Tight.apk', '_blank');
      }
    };

    /* ========== 生命周期 ========== */
    onMounted(() => {
      if (!prefersReducedMotion()) startShots();
    });
    onUnmounted(() => {
      stopShots();
      document.documentElement.classList.remove('brand-open');
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(NavBar), _createElementVNode("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[12] || (_cache[12] = _createElementVNode("header", {
        class: "dl-top"
      }, [_createElementVNode("h1", {
        class: "dl-title"
      }, "Sleep Tight App"), _createElementVNode("p", {
        class: "dl-meta"
      }, "最新版本 v2.3.13 · 支持 iOS 12.0+ / Android 8.0+ · 需开启蓝牙")], -1)), _unref(isWechat) ? (_openBlock(), _createElementBlock("p", _hoisted_4, " 你在微信里打开了本页，直接点下载会被微信拦截 —— 请点右上角「···」，选择「在浏览器中打开」再下载。 ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "shots",
        onMouseenter: pauseShots,
        onMouseleave: resumeShots,
        onTouchstartPassive: onTouchStart,
        onTouchend: onTouchEnd
      }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "shots__track",
        style: _normalizeStyle({
          transform: `translateX(${-(shotIndex.value * 100)}%)`
        })
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(screens, shot => {
        return _createElementVNode("figure", {
          key: shot.id,
          class: "shot"
        }, [!missingShots.value.includes(shot.id) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: shot.src,
          alt: `Sleep Tight App · ${shot.label}`,
          onError: $event => onShotError(shot.id)
        }, null, 40, _hoisted_7)) : (_openBlock(), _createElementBlock("figcaption", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(shot.label), 1), _createElementVNode("small", null, "截图待补：放到 public" + _toDisplayString(shot.src) + " 即可自动显示", 1)]))]);
      }), 64))], 4)]), _createElementVNode("div", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(screens, (shot, index) => {
        return _createElementVNode("button", {
          key: shot.id,
          type: "button",
          class: _normalizeClass(["shots__dot", {
            'is-on': shotIndex.value === index
          }]),
          "aria-label": `查看第 ${index + 1} 张截图：${shot.label}`,
          onClick: $event => goToShot(index)
        }, null, 10, _hoisted_10);
      }), 64))])], 32), _createElementVNode("div", _hoisted_11, [deviceHint.value ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(deviceHint.value), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["dl-btn dl-btn--dark", {
          'is-suggested': suggested.value === 'ios'
        }]),
        onClick: _cache[0] || (_cache[0] = $event => handleDownload('ios'))
      }, _cache[4] || (_cache[4] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true"
      }, [_createElementVNode("path", {
        fill: "currentColor",
        d: "M16.37 1.43c0 1.14-.42 2.2-1.26 3.02-.87.86-1.9 1.35-2.94 1.26-.02-.11-.03-.28-.03-.5 0-1.08.46-2.23 1.28-3.06.41-.42.93-.77 1.56-1.05.62-.28 1.2-.44 1.72-.47.02.28.02.55.02.8h-.35zM19.77 17.73c-.34.79-.74 1.53-1.2 2.2-.63.9-1.15 1.52-1.55 1.87-.62.57-1.28.86-1.99.88-.51 0-1.12-.14-1.85-.43-.72-.29-1.39-.43-1.99-.43-.64 0-1.32.14-2.06.43-.74.29-1.33.44-1.77.45-.68.03-1.36-.27-2.03-.9-.43-.39-.97-1.03-1.62-1.94-.7-.97-1.27-2.09-1.72-3.37-.48-1.38-.72-2.71-.72-4 0-1.48.32-2.75.96-3.82.51-.86 1.18-1.54 2.02-2.04.84-.5 1.75-.76 2.73-.78.54 0 1.25.17 2.13.5.87.33 1.44.5 1.69.5.19 0 .83-.2 1.91-.59.99-.36 1.79-.51 2.4-.45 1.77.14 3.1.84 3.99 2.1-1.58.96-2.36 2.3-2.34 4.02.02 1.34.5 2.46 1.44 3.34.42.4.9.71 1.44.94-.11.33-.23.65-.36.96z"
      })], -1), _createElementVNode("span", null, "App Store", -1)]), 2), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["dl-btn dl-btn--dark", {
          'is-suggested': suggested.value === 'android'
        }]),
        onClick: _cache[1] || (_cache[1] = $event => handleDownload('android'))
      }, _cache[5] || (_cache[5] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" aria-hidden=\"true\" data-v-7fb3e6db><path d=\"M6 9.5h12v6.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 6 16V9.5Z\" data-v-7fb3e6db></path><path d=\"M4 10.8v5.4M20 10.8v5.4\" stroke-linecap=\"round\" data-v-7fb3e6db></path><path d=\"M8.2 6.3 6.6 3.9M15.8 6.3l1.6-2.4\" stroke-linecap=\"round\" data-v-7fb3e6db></path><circle cx=\"9.6\" cy=\"8.1\" r=\"0.9\" fill=\"currentColor\" stroke=\"none\" data-v-7fb3e6db></circle><circle cx=\"14.4\" cy=\"8.1\" r=\"0.9\" fill=\"currentColor\" stroke=\"none\" data-v-7fb3e6db></circle></svg><span data-v-7fb3e6db>应用市场</span>", 2)]), 2), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["dl-btn dl-btn--outline", {
          'is-suggested': suggested.value === 'apk'
        }]),
        onClick: _cache[2] || (_cache[2] = $event => handleDownload('apk'))
      }, _cache[6] || (_cache[6] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "1.7",
        "aria-hidden": "true"
      }, [_createElementVNode("path", {
        d: "M12 4v10",
        "stroke-linecap": "round"
      }), _createElementVNode("path", {
        d: "m8 10 4 4 4-4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }), _createElementVNode("path", {
        d: "M5 19h14",
        "stroke-linecap": "round"
      })], -1), _createElementVNode("span", null, "APK 直装", -1)]), 2)]), _cache[10] || (_cache[10] = _createElementVNode("ul", {
        class: "dl-chips"
      }, [_createElementVNode("li", null, "脑电设备连接"), _createElementVNode("li", null, "个性化助眠音频"), _createElementVNode("li", null, "近七天睡眠报告")], -1)), _cache[11] || (_cache[11] = _createElementVNode("p", {
        class: "dl-note"
      }, " iPhone 用 App Store 最省事；Android 可以走品牌应用市场，也可以直接装 APK；在电脑上建议用手机扫码。 ", -1)), _unref(isDesktop) ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("figure", null, [_createElementVNode("img", {
        src: _unref(iosQr),
        alt: "iOS 版 App 下载二维码"
      }, null, 8, _hoisted_15), _cache[7] || (_cache[7] = _createElementVNode("figcaption", null, "iOS", -1))]), _createElementVNode("figure", null, [_createElementVNode("img", {
        src: _unref(androidQr),
        alt: "Android 版 App 下载二维码"
      }, null, 8, _hoisted_16), _cache[8] || (_cache[8] = _createElementVNode("figcaption", null, "Android", -1))]), _cache[9] || (_cache[9] = _createElementVNode("p", null, "用手机相机或微信扫一扫", -1))])) : _createCommentVNode("", true)])])])])]), showBrandModal.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "brand-overlay",
        onClick: _withModifiers(closeBrandModal, ["self"])
      }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("button", {
        type: "button",
        class: "brand-modal__close",
        "aria-label": "关闭",
        onClick: closeBrandModal
      }, "✕"), _cache[15] || (_cache[15] = _createElementVNode("h3", {
        class: "brand-modal__title"
      }, "选择手机品牌", -1)), _cache[16] || (_cache[16] = _createElementVNode("p", {
        class: "brand-modal__note"
      }, "将跳转到你手机上的应用商店", -1)), _createElementVNode("ul", _hoisted_18, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(brandList, brand => {
        return _createElementVNode("li", {
          key: brand.key
        }, [_createElementVNode("button", {
          type: "button",
          class: "brand-row",
          onClick: $event => goToBrandStore(brand)
        }, [_createElementVNode("span", null, _toDisplayString(brand.name), 1), _cache[13] || (_cache[13] = _createElementVNode("i", {
          "aria-hidden": "true"
        }, "→", -1))], 8, _hoisted_19)]);
      }), 64))]), _createElementVNode("div", _hoisted_20, [_cache[14] || (_cache[14] = _createElementVNode("p", null, "找不到你的品牌？", -1)), _createElementVNode("button", {
        type: "button",
        class: "brand-apk",
        onClick: _cache[3] || (_cache[3] = $event => handleDownload('apk'))
      }, " 直接下载 APK 安装 ")])])])) : _createCommentVNode("", true), _createVNode(Footer)], 64);
    };
  }
};